import Vue from 'vue';

// Shared only by the classic chart and its list, not by the modern explorer.
export const legacyCollectionStatus = Vue.observable({ error: '' });
